import React from 'react';
import { ShoppingBag, CreditCard, ClipboardList, Truck, Home } from 'lucide-react';
import { useSettings } from '../hooks/useSettings';

const BOSS_IJAN_IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/9f4j2sek_473322819_595829349867868_2473331831266740842_n.jpg";

const steps = [
  { num: 1, title: "Pilih Produk", desc: "Pilih produk yang acik-acik inginkan", icon: ShoppingBag },
  { num: 2, title: "Buat Pembayaran", desc: "Sila buat pembayaran atas talian di dalam website", icon: CreditCard },
  { num: 3, title: "Isi Maklumat Shipping", desc: "Berikan maklumat penghantaran dengan lengkap", icon: ClipboardList },
  { num: 4, title: "Shipping Barang", desc: "Team Boss Ijan akan semak order dan sedia untuk dipos", icon: Truck },
  { num: 5, title: "Barang Sampai", desc: "Tunggu barang sampai di rumah. Mudah kan!", icon: Home }
];

const HeroSection = () => {
  const settings = useSettings();
  const whatsappLink = `https://wa.me/6${settings.whatsappNumber}`;

  return (
    <section className="relative overflow-hidden" data-testid="hero-section">
      {/* Boss Ijan Background */}
      <div className="absolute inset-0">
        <img
          src={BOSS_IJAN_IMG}
          alt="Boss Ijan"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/40" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 py-16 md:py-24">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* Left - Quote & CTA */}
          <div className="text-white">
            <div className="inline-block bg-amber-500/20 border border-amber-400/30 backdrop-blur-sm text-amber-300 text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-widest mb-6">
              Gudang Boss Ijan
            </div>
            
            <blockquote className="mb-6">
              <p className="text-2xl md:text-3xl lg:text-4xl font-bold leading-tight tracking-tight">
                "Kejayaan Adalah Dari
                <br />
                <span className="text-amber-400">Sekecil-Kecil Pencapaian"</span>
              </p>
              <footer className="mt-4 text-lg text-amber-300 font-semibold">
                — Boss Ijan
              </footer>
            </blockquote>

            <p className="text-white/70 text-sm md:text-base mb-8 max-w-md leading-relaxed">
              Perabot jati asli dari Jepara, terus dari kilang ke rumah anda. 
              Harga gudang, kualiti premium.
            </p>

            <div className="flex flex-wrap gap-3">
              <a
                href="#perabot"
                className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white px-6 py-3 rounded-xl font-bold flex items-center gap-2 transition-all shadow-lg shadow-amber-500/25 text-sm"
                data-testid="hero-cta-btn"
              >
                <ShoppingBag size={18} />
                Lihat Koleksi
              </a>
              <a
                href={whatsappLink}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-white/20 backdrop-blur-sm border border-white/20 text-white px-6 py-3 rounded-xl font-semibold flex items-center gap-2 transition-all text-sm"
                data-testid="hero-wa-btn"
              >
                Hubungi Kami
              </a>
            </div>
          </div>

          {/* Right - Steps */}
          <div className="bg-white/10 backdrop-blur-md border border-white/15 rounded-2xl p-6 md:p-8" data-testid="hero-steps">
            <h3 className="text-white font-bold text-lg mb-5 text-center">
              Proses Tempahan
            </h3>
            <div className="space-y-1">
              {steps.map((step, index) => {
                const Icon = step.icon;
                return (
                  <div key={step.num} className="flex gap-3 group">
                    <div className="flex flex-col items-center">
                      <div className="w-9 h-9 bg-amber-500/80 text-white rounded-lg flex items-center justify-center shadow group-hover:scale-110 transition-transform">
                        <Icon size={16} />
                      </div>
                      {index < 4 && (
                        <div className="w-0.5 h-8 bg-white/20 mt-1" />
                      )}
                    </div>
                    <div className="flex-1 pb-2 pt-0.5">
                      <span className="text-amber-400/80 text-[10px] font-bold uppercase tracking-widest">Langkah {step.num}</span>
                      <h4 className="text-white font-semibold text-sm">{step.title}</h4>
                      <p className="text-white/50 text-xs leading-relaxed">{step.desc}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
